import { BaseApiService } from './base';

export class EvaluationService extends BaseApiService {
  async getEvaluationProjects(): Promise<any[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      {
        id: '1',
        name: 'Projet Évaluation A',
        status: 'en_cours',
        progress: 75,
        startDate: '2024-01-01',
        endDate: '2024-12-31'
      },
      {
        id: '2',
        name: 'Projet Évaluation B',
        status: 'planifié',
        progress: 25,
        startDate: '2024-06-01',
        endDate: '2024-11-30'
      }
    ];
  }

  async createEvaluationProject(projectData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 800));
    return {
      id: Date.now().toString(),
      ...projectData,
      createdAt: new Date(),
    };
  }

  async updateEvaluationProject(id: string, projectData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return {
      id,
      ...projectData,
      updatedAt: new Date(),
    };
  }

  async deleteEvaluationProject(id: string): Promise<{ success: boolean }> {
    await new Promise(resolve => setTimeout(resolve, 400));
    return { success: true };
  }

  async getEvaluationStats(): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      totalProjects: 5,
      activeProjects: 3,
      completedProjects: 2,
      averageProgress: 65
    };
  }

  async getLogFrame(projectId: string): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      projectId,
      objectives: ['Objectif 1', 'Objectif 2'],
      activities: ['Activité 1', 'Activité 2'],
      indicators: ['Indicateur 1', 'Indicateur 2']
    };
  }

  async updateLogFrame(projectId: string, logFrameData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return { projectId, ...logFrameData, updatedAt: new Date() };
  }

  async getActionPlan(projectId: string): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      projectId,
      actions: [
        { id: '1', name: 'Action 1', status: 'en_cours', deadline: '2024-12-31' },
        { id: '2', name: 'Action 2', status: 'planifié', deadline: '2024-11-30' }
      ]
    };
  }

  async updateActionPlan(projectId: string, actionPlanData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return { projectId, ...actionPlanData, updatedAt: new Date() };
  }

  async getCollectionForms(projectId: string): Promise<any[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      { id: '1', name: 'Formulaire 1', type: 'questionnaire' },
      { id: '2', name: 'Formulaire 2', type: 'entretien' }
    ];
  }

  async createCollectionForm(projectId: string, formData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 800));
    return {
      id: Date.now().toString(),
      projectId,
      ...formData,
      createdAt: new Date()
    };
  }

  async updateCollectionForm(projectId: string, formId: string, formData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return {
      id: formId,
      projectId,
      ...formData,
      updatedAt: new Date()
    };
  }

  async deleteCollectionForm(projectId: string, formId: string): Promise<{ success: boolean }> {
    await new Promise(resolve => setTimeout(resolve, 400));
    return { success: true };
  }

  async getPerformanceAnalysis(projectId: string): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      projectId,
      metrics: {
        efficiency: 85,
        effectiveness: 92,
        impact: 78
      },
      trends: [
        { month: 'Jan', value: 70 },
        { month: 'Feb', value: 75 },
        { month: 'Mar', value: 80 }
      ]
    };
  }

  async updatePerformanceAnalysis(projectId: string, analysisData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return { projectId, ...analysisData, updatedAt: new Date() };
  }

  async getStrategicReports(projectId: string): Promise<any[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      { id: '1', name: 'Rapport Stratégique 1', date: '2024-01-15' },
      { id: '2', name: 'Rapport Stratégique 2', date: '2024-02-15' }
    ];
  }

  async createStrategicReport(projectId: string, reportData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 800));
    return {
      id: Date.now().toString(),
      projectId,
      ...reportData,
      createdAt: new Date()
    };
  }

  async updateStrategicReport(projectId: string, reportId: string, reportData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return {
      id: reportId,
      projectId,
      ...reportData,
      updatedAt: new Date()
    };
  }

  async deleteStrategicReport(projectId: string, reportId: string): Promise<{ success: boolean }> {
    await new Promise(resolve => setTimeout(resolve, 400));
    return { success: true };
  }

  async getEvaluationActivities(projectId: string): Promise<any[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      { id: '1', name: 'Activité 1', type: 'collecte', status: 'terminé' },
      { id: '2', name: 'Activité 2', type: 'analyse', status: 'en_cours' }
    ];
  }

  async createEvaluationActivity(projectId: string, activityData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 800));
    return {
      id: Date.now().toString(),
      projectId,
      ...activityData,
      createdAt: new Date()
    };
  }

  async updateEvaluationActivity(projectId: string, activityId: string, activityData: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 600));
    return {
      id: activityId,
      projectId,
      ...activityData,
      updatedAt: new Date()
    };
  }

  async deleteEvaluationActivity(projectId: string, activityId: string): Promise<{ success: boolean }> {
    await new Promise(resolve => setTimeout(resolve, 400));
    return { success: true };
  }

  async getEvaluationData(projectId: string, formId: string): Promise<any[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return [
      { id: '1', formId, value: 'Réponse 1', date: '2024-01-15' },
      { id: '2', formId, value: 'Réponse 2', date: '2024-01-16' }
    ];
  }

  async createEvaluationData(projectId: string, formId: string, data: any): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 800));
    return {
      id: Date.now().toString(),
      projectId,
      formId,
      ...data,
      createdAt: new Date()
    };
  }

  async getProjectProgress(projectId: string): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      projectId,
      progress: 75,
      milestones: [
        { id: '1', name: 'Milestone 1', completed: true },
        { id: '2', name: 'Milestone 2', completed: false }
      ]
    };
  }

  async getEvaluationDashboard(): Promise<any> {
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
      totalProjects: 5,
      activeProjects: 3,
      recentActivities: [
        { id: '1', type: 'collecte', project: 'Projet A', date: '2024-01-15' },
        { id: '2', type: 'analyse', project: 'Projet B', date: '2024-01-14' }
      ]
    };
  }
}

// Instance singleton
export const evaluationService = new EvaluationService();
